var _defs, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstratradeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 88,
    viewBox: "0 0 256 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGreen",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24B653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#139246"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E295D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062140"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 64H38L10 0H26L41 32L52 9L60 27L52 41V64Z",
    fill: "url(#logoBlue)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 0L10 0L0 20L8 37L26 0Z",
    fill: "url(#logoGreen)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 44L54 16L60 27L41 56L32 44Z",
    fill: "url(#logoGreen)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 42,
    fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 600,
    fontSize: 32,
    fill: "#24B653"
  }, "Astra")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 72,
    fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 600,
    fontSize: 32,
    fill: "#0E295D"
  }, "Trade")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstratradeLogo);
export default __webpack_public_path__ + "static/media/astratrade-logo.ebdb736002b8da4ee934ba8a4dacfe0c.svg";
export { ForwardRef as ReactComponent };